import SocketIo from './socket-io';
import EventEmitter from 'eventemitter3';
import { useStateful } from 'react-hanger';
import { useEffect } from 'react';
import { store as messages } from '../functions/messages/store';
import { store as broadcast } from '../functions/broadcast/store';
import { store as animation } from '../functions/animation/store';
import { store as gift } from '../functions/gift/store/gift';
import { store as bag } from '../functions/gift/store/bag';
import { store as giftBottom } from '../functions/gift/store/gift-bottom';
import { store as marquee } from '../functions/marquee/store';
import { user, sdata, messenger } from 'lib';
import throttle from 'lodash/throttle';
import { getGlobalStore } from 'stores';

const socketEvent = new EventEmitter();

let broadcastActions = [];

let socket = null;
let store = null;

let getWidgetStore = () => {
  return {
    messages,
    broadcast,
    animation,
    gift,
    bag,
    giftBottom,
    marquee,
  };
};

const destroy = () => {
  socketEvent.removeAllListeners();
  socket && socket.close();
  socket = null;
};

let disableActions = [];

const init = (roomId, roomStore, query) => {
  store = roomStore;

  messenger.parentActions.addSocket = (msg) => {
    addBroadcastActions(msg.data.action);
  };

  const onConnected = throttle(() => {
    sendMsg({
      action: 'statistics.info',
      data: sdata.getSaProperties({
        video_channel: query.clickfrom || '',
      }),
    });

    getGlobalStore().setSocketReady(true);

    // MM.event.emit('socket.connect')

    socketEvent.emit('socket.connected');

    console.log('socket [onConnected]');

    sendMsg({
      action: 'watch.start',
    });

    setTimeout(() => {
      sdata.track('startWatching', {
        starId: roomId + '',
        roomType: 'PC',
        video_channel: query.clickfrom || '',
        client_type: 'PC',
        enter_time: Date.now(),
        level: user.getRichLevel(),
        followed: 'false',
      });
    }, 3000);
  }, 5000);

  socket = new SocketIo({
    roomId,
    onConnected,
    onDisconnected: () => {},
    onMessage: (res) => {
      let msg = res;
      if (!res.action) {
        msg = {
          action: 'message.chat',
          data_d: res,
        };
      }

      if (msg.action.indexOf('ultraman') > -1) {
        return;
      }

      if (disableActions.includes(msg.action)) {
        return;
      }

      console.log(
        `%csocket[${msg.action}]`,
        'color:#109a0d;font-weight:bold;',
        msg,
        roomStore,
        getWidgetStore(),
      );

      if (broadcastActions.includes(msg.action)) {
        messenger.send({
          action: 'socketMsg',
          data: msg,
        });
      }

      if (event.onBeforeEmit(msg.action, msg, roomStore, getWidgetStore())) {
        socketEvent.emit(msg.action, msg, roomStore, getWidgetStore());
        const actionArray = msg.action.split('.');
        // 避免 没有 点号分隔的action 重复触发，如 xxx.yyy 征程，xxx 的action 会重复
        if (actionArray.length > 1) {
          socketEvent.emit(actionArray[0], msg, roomStore, getWidgetStore());
        }
        socketEvent.emit('__common.socket', msg, roomStore, getWidgetStore());
      }
    },
    onError: () => {},
  });
};

const useEventListen = (name, fn = (data, roomStore, widgetStore) => {}) => {
  let res = useStateful(null);

  useEffect(() => {
    let _fn = (data, roomStore, widgetStore) => {
      res.setValue(data);
      fn(data, roomStore, widgetStore);
    };
    socketEvent.on(name, _fn);
    return () => {
      socketEvent.off(name, _fn);
    };
  }, [name, fn]);
  return res.value;
};

const sendMsg = (msg) => {
  if (socket) {
    socket.sendMsg(msg);
  } else {
    console.warn('socket is null, sendMsg', msg);
  }
};

const event = {
  onBeforeEmit: (action, msg, roomStore, widgetStore) => {
    // return false  即忽略此消息
    return msg;
  },
};

/**
 * 触发socket消息
 * @param action
 * @param msg
 */
const emitMsg = (action, msg = {}) => {
  if (typeof action === 'object') {
    socketEvent.emit(action.action, action, store, getWidgetStore());
    socketEvent.emit('__common.socket', action, store, getWidgetStore());
    if (broadcastActions.includes(action.action)) {
      messenger.send({
        action: 'socketMsg',
        data: action,
      });
    }
  } else {
    socketEvent.emit(action, msg, store, getWidgetStore());
    socketEvent.emit('__common.socket', msg, store, getWidgetStore());
    if (broadcastActions.includes(msg.action)) {
      messenger.send({
        action: 'socketMsg',
        data: msg,
      });
    }
  }
};

const addBroadcastActions = (actions) => {
  broadcastActions = broadcastActions.concat(actions);
};

const getBroadcastActions = () => {
  return broadcastActions;
};

const addDisableAction = (action) => {
  disableActions.push(action);
  return disableActions;
};

const removeDisableAction = (action) => {
  disableActions = disableActions.filter((item) => {
    return item !== action;
  });
  return disableActions;
};

export default {
  init,
  sendMsg,
  destroy,
  socketEvent,
  useEventListen,
  useSocketListen: useEventListen,
  event,
  emitMsg,
  addBroadcastActions,
  broadcastActions,
  getBroadcastActions,

  addDisableAction,
  removeDisableAction,
  disableActions,
};
